import { createAction, props } from '@ngrx/store';
import { IGenericError, ErrorResponse } from '../../../core/models/generic-models';
import { ILogoutRequest } from '../models/logout.model';

export const clearStore = createAction('[Logout] Clear Store');

export const loadLogoutRequest = createAction('[Logout] Logout Request', props<{ request: ILogoutRequest }>());

export const loadLogoutSuccess = createAction('[Logout] Logout Success', props<{ response: string }>());

export const loadLogoutFailure = createAction('[Logout] Logout Request', props<{ error: IGenericError<ErrorResponse> }>());
